<div class="client_pageBody">
  <!-- <div class="text-2xl font-bold pl-4">{{_common.findSpace.search_result}}</div> -->

  <div class="max-height body_section">
    <app-space-wizard-result></app-space-wizard-result>
  </div>
</div>
